import styled from '@emotion/styled';
import { r, tabletUp } from './shared/lib/responsive';

export const AppShell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  min-height: 100dvh;
  width: 100%;
  padding: 0;
  box-sizing: border-box;
  background: #000;
  overflow: hidden;

  ${tabletUp} {
    ${r('padding', 16)}
  }
`;

export const AppFrame = styled.main`
  position: relative;
  flex-shrink: 0;
  width: 100%;
  ${r('height', 812)}
  max-width: var(--screen-max-width);
  aspect-ratio: 375 / 812;
  border-radius: 0;
  overflow: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  & * {
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  & *::-webkit-scrollbar {
    display: none;
  }

  box-shadow: 0 5.3333vw 6.6667vw rgba(0, 0, 0, 0.25);
  transform-origin: center center;
  background: var(--color-bg-base);

  ${tabletUp} {
    border-radius: 24px;
    box-shadow: 0 20px 25px rgba(0, 0, 0, 0.25);
    transform: scale(min(1, calc((100dvh - 32px) / 812)));
  }
`;
